import React, {useContext, useEffect, useRef, useState} from "react"
import {api} from "../../api/api";
import Banner from "./Banner";
import styled from "styled-components";
import Poll from "./Poll";
import UserContext from "../../context/UserContext";

const Advertising = ({adSuccess}) => {
    const [currentQueue, setCurrentQueue] = useState({}) // текущий объект из очереди  
    const [mainQueue, setMainQueue] = useState([]) // сама очередь 
    const [queueFlag, setQueueFlag] = useState(false) // 
    const [queueCount, setQueueCount] = useState(5)
    const timerRef = useRef(null)
    const skipTimerRef = useRef(null)
    const {unknown_device} = useContext(UserContext)

    const clearDelay = (array) => {
        if (array.length === 0) {
            return adSuccess()
        }

        const firstItem = array.shift()
        setMainQueue(array)
        setCurrentQueue(firstItem)
        stopTimer()
    }
    console.log("adv")
    const nextFunc = () => clearDelay(mainQueue)

    const stopTimer = () => {
        setQueueCount(10)
        clearTimeout(timerRef.current)
        timerRef.current = null
    }

    useEffect(() => {
        timerRef.current = setTimeout(() => {
            if (queueCount === 0) {
                clearTimeout(timerRef.current)
                return timerRef.current = null
            }

            setQueueCount(queueCount - 1)
        }, 1000)
    }, [queueCount])

    useEffect(() => {
        if (queueCount <= 0 && (currentQueue.type === "image" || currentQueue.type === "video")) {
            skipTimerRef.current = setTimeout(() => {
                // console.log("Timeout 30sec")
                api.promoEvent(currentQueue.id, "timeout")
                nextFunc()
            }, 1000 * 30)
        }
    }, [queueCount])

    useEffect(() => {
        api.getLayers().then(res => {
            if (res.status === 200) {
                const polls = Object.values(res.data.polls)
                const ad = Object.values(res.data.ad)
                const data = polls.concat(ad)
                if (data.length === 0 ) {
                    adSuccess()
                    return
                }
                const sortedData = data.sort((a, b) => a.priority - b.priority)
                const firstEl = sortedData.shift()
                setCurrentQueue(firstEl)
                setMainQueue(sortedData)
            }
        }).catch(err => {
            console.log(err.message);
        })
    }, [unknown_device])

    useEffect(() => {
        if (queueFlag) {
            clearDelay(mainQueue)
            setQueueFlag(false)
        }
    }, [queueFlag])

    return (
        <>
            {
                (Object.keys(currentQueue).length !== 0) && (
                    <>
                        {
                            ("type" in currentQueue)
                                ? <Banner
                                    skipTimerRef={skipTimerRef}
                                    adSuccess={adSuccess}
                                    value={currentQueue}
                                    timer={queueCount}
                                    setTimer={setQueueCount}
                                    nextFunc={nextFunc}
                                />
                                : <Poll
                                    nextFunc={nextFunc}
                                    poll={currentQueue}
                                    timeout={queueCount}
                                    setTimer={setQueueCount}
                                    queueFlag={queueFlag}
                                />
                        }
                    </>
                )
            }
        </>
    )
}

const EmptyBlock = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  background-color: #fff;
`
 
export const AdModal = ({setAuth, setEmptyFlag}) => {
    const adSuccess = () => {
        setEmptyFlag(false)
        setAuth(true)
    }

    return <EmptyBlock>
        <Advertising adSuccess={adSuccess}/>
    </EmptyBlock>
}

export default Advertising